import React from 'react'
import SvgContact from '../../images/svg/SvgContact'

export default function Contact() {
    return(
        <div>
            <a target="_blank" href="mailto:hectoracosta@me.com">
                <SvgContact />
            </a>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/containers/navigation/Contact.jsx